import { Button, Container, Grid } from '@material-ui/core'
import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiVerifyTeacherEmail, getConfigSync } from '../../api'

interface Props {
    token: string
}

export default function VerifyTeacherEmailPage({ token }: Props) {
    const [status, setStatus] = useState<'ready' | 'loading' | 'success' | 'expired' | 'invalid' | 'already_used' | 'not_allowed' | 'rate_limited' | 'error'>('ready')

    async function confirmEmail() {
        setStatus('loading')
        const res = await apiVerifyTeacherEmail(token)

        if (res.ok) {
            setStatus('success')
            return
        }

        const reason = res.reason
        if (
          reason === 'expired' ||
          reason === 'invalid' ||
          reason === 'already_used' ||
          reason === 'not_allowed' ||
          reason === 'rate_limited'
        ) {
            setStatus(reason)
            return
        }

        setStatus('error')
    }

    return (
      <Container maxWidth="sm">
          <Grid container direction="column" alignItems="center" style={{ marginTop: 40 }}>
              <h1>{getConfigSync().competitionShortName} Exam Portal</h1>

              {status === 'ready' && (
                <Fragment>
                    <p style={{ textAlign: 'center' }}>
                        Confirm your email address to continue. Opening this page does not confirm it by itself.
                    </p>
                    <Button color="primary" variant="contained" onClick={confirmEmail}>
                        Confirm
                    </Button>
                </Fragment>
              )}

              {status === 'loading' && <p>Verifying your email address...</p>}

              {status === 'success' && (
                <Fragment>
                    <p style={{ color: 'green', textAlign: 'center' }}>
                        Your email has been verified. Please log in and review your details on the Update Details page to reactivate your account.
                    </p>
                    <Button color="primary" variant="outlined" component={Link} to="/login">
                        Go to login
                    </Button>
                </Fragment>
              )}

              {status === 'expired' && (
                <Fragment>
                    <p style={{ color: 'red', textAlign: 'center' }}>
                        This verification link has expired. Please log in again to receive a new link.
                    </p>
                    <Button color="primary" variant="outlined" component={Link} to="/login">
                        Go to login
                    </Button>
                </Fragment>
              )}

              {status === 'invalid' && (
                <Fragment>
                    <p style={{ color: 'red', textAlign: 'center' }}>
                        This verification link is invalid.
                    </p>
                    <Button color="primary" variant="outlined" component={Link} to="/login">
                        Go to login
                    </Button>
                </Fragment>
              )}

              {status === 'already_used' && (
                <Fragment>
                    <p style={{ textAlign: 'center' }}>
                        This verification link has already been used. Your account is active. Please log in.
                    </p>
                    <Button color="primary" variant="outlined" component={Link} to="/login">
                        Go to login
                    </Button>
                </Fragment>
              )}

              {status === 'not_allowed' && (
                <Fragment>
                    <p style={{ color: 'red', textAlign: 'center' }}>
                        This verification link cannot be used for the current account status.
                    </p>
                    <Button color="primary" variant="outlined" component={Link} to="/login">
                        Go to login
                    </Button>
                </Fragment>
              )}

              {status === 'rate_limited' && (
                <Fragment>
                    <p style={{ color: 'red', textAlign: 'center' }}>
                        Too many attempts. Please wait a few minutes and try again.
                    </p>
                    <Button color="primary" variant="outlined" component={Link} to="/login">
                        Go to login
                    </Button>
                </Fragment>
              )}

              {status === 'error' && (
                <Fragment>
                    <p style={{ color: 'red', textAlign: 'center' }}>
                        We could not verify your email. Please try again later.
                    </p>
                    <Button color="primary" variant="outlined" component={Link} to="/login">
                        Go to login
                    </Button>
                </Fragment>
              )}
          </Grid>
      </Container>
    )
}
